var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 14.5V14C23 10.229 23 8.343 21.828 7.172C20.656 6.001 18.771 6 15 6C11.229 6 9.343 6 8.172 7.172C7.001 8.344 7 10.229 7 14V20C7 21.864 7 22.796 7.304 23.53C7.50502 24.0154 7.79968 24.4564 8.17115 24.8278C8.54263 25.1993 8.98364 25.494 9.469 25.695C10.204 26 11.136 26 13 26M11 11H19M11 15H15",
    stroke: "#4A5568",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.283 23.004C19.223 22.116 19.118 21.166 18.682 20.092C18.309 19.176 18.413 17.021 20.5 17.021C22.587 17.021 22.666 19.176 22.294 20.091C21.858 21.166 21.776 22.116 21.718 23.004M25 26H16V24.754C16 24.308 16.266 23.915 16.653 23.793L18.908 23.077C19.0693 23.0257 19.234 23 19.402 23H21.598C21.766 23 21.9307 23.0257 22.092 23.077L24.347 23.793C24.734 23.915 25 24.308 25 24.754V26Z",
    stroke: "#4A5568",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.2ca1789a5623f660b2ef552a5010317a.svg";
export { ForwardRef as ReactComponent };